import { createContext, useContext, useEffect, useState, ReactNode } from 'react';

const STORAGE_KEY = 'pp_v2_enabled';

interface V2ContextValue {
  enabled: boolean;
  toggle: () => void;
  setEnabled: (v: boolean) => void;
}

const V2Context = createContext<V2ContextValue | null>(null);

export function V2Provider({ children }: { children: ReactNode }) {
  const [enabled, setEnabled] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem(STORAGE_KEY) === 'true';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(enabled));
  }, [enabled]);

  return (
    <V2Context.Provider
      value={{
        enabled,
        setEnabled,
        toggle: () => setEnabled((v) => !v),
      }}
    >
      {children}
    </V2Context.Provider>
  );
}

export function useV2(): V2ContextValue {
  const ctx = useContext(V2Context);
  if (!ctx) throw new Error('useV2 must be used inside V2Provider');
  return ctx;
}
